function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as o } from "./index.es33.js";
import { t as n } from "./index.es106.js";
import { clsx as s } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as a } from "./index.es36.js";
import { Icon as i } from "./index.es7.js";
import { PositionVariants as l } from "./index.es172.js";
import { Tooltip as c } from "./index.es13.js";
import "react";
import "nanoid";
import "./index.es15.js";
import r from "./index.es564.js";
var P = function P(_ref) {
  var t = _ref.isDisabled,
    m = _ref.isActive,
    p = _ref.onClick;
  return o.jsx(c, {
    isVisibleDisabled: t,
    position: l.underCenter,
    title: n("component_component_variableIcon_variableIconTooltipLabel"),
    children: o.jsx("button", {
      type: "button",
      disabled: t,
      className: s(r.variableBtn, _defineProperty({}, r.active, m)),
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: p,
      children: o.jsx(i, {
        size: 16,
        color: a.gray6,
        icon: i.icons.system.s.utilities.variable
      })
    })
  });
};
export { P as VariableIcon };